import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const Museums = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddMuseum = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditMuseum = () => {
  return (
    
      
        <Edit />
      
    
  );
};
